import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { Picture } from 'app/components/commons/Uploader/Types';
import { apiMutation } from 'app/utils/request/api';

import { hotelPicturesPath } from './useHotelPictures';

const saveGalleryPath = 'hotels/gallery' as const;

export type SaveGalleryPayload = {
  id: number;
  name: string;
  pictures: Picture[];
  kind: string;
};

export function useSaveGallery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SaveGalleryPayload) =>
      apiMutation('POST', { path: saveGalleryPath }, payload) as Promise<void>,
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({
        queryKey: [hotelPicturesPath, { hotelId: payload.id }],
      });
    },
    onError: () => {
      message.error('Error saving Hotel Gallery');
    },
  });
}
